import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { Star } from "lucide-react";

const reviews = [
    {
        id: 1,
        name: "Chirine Jlidi",
        rating: 5,
        daysAgo: "a month ago",
        review:
            "We had an amazing experience with Nova Capital Real Estate LLC. Karan was our agent, and honestly, he made the whole process of buying our home so smooth and stress-free. He was always friendly, easy to talk to, and guided us through every step with so much patience. Thanks to him, we found the perfect house in the right place. We’re really happy and grateful for all his help. Highly recommend Karan and the Nova Capital team!",
    },
    {
        id: 2,
        name: "Stephen San Tiago",
        rating: 5,
        daysAgo: "6 months ago",
        review:
            "I made a query to them regarding our plans in buying a property in Dubai and the Property Consultant I was with was very well spoken and knowledgeable about her work. She knows about the trend, great locations and all. She did a great job in assisting us with all of our questions and doubt. Great Job Nova.",
    },
    {
        id: 3,
        name: "TRANG LE",
        rating: 5,
        daysAgo: "a month ago",
        review:
            "I had a great experience buying an apartment with Asad. He was very helpful throughout the process and provided all the information I needed. On top of that, he even helped me when my car broke down on the same day I went to finalize the purchase. Truly a kind and reliable person—what a nice guy!",
    },
    {
        id: 4,
        name: "Jawad Ullah",
        rating: 5,
        daysAgo: "5 months ago",
        review:
            "I had a fantastic experience with Nova Capital. From start to finish, their team was supportive, knowledgeable, and always available to answer my questions. They made the entire process smooth and stress-free. I highly recommend them.",
    },
    {
        id: 5,
        name: "Krishna",
        rating: 4,
        daysAgo: "a month ago",
        review:
            "I had the pleasure of working with Nova Capital - Lokesh as my property agent and was thoroughly impressed by his professionalism and expertise. He demonstrated in-depth market knowledge, clear communication, and a client-first approach throughout the process. I highly recommend Nova Capital to anyone seeking a reliable and trusted property partner. Their commitment to excellence sets them apart in the market.",
    },
    {
        id: 6,
        name: "Amandeep Singh",
        rating: 5,
        daysAgo: "a month ago",
        review:
            "Had a great experience working with them. Janvii was really helpful and genuine, clearly understood my requirements and helped me accordingly. Would recommend to anyone who wants to buy a property in Dubai, they offer some great deals and projects.",
    },
];

export default function ReviewCarousel() {
    return (
        <section className="bg-[#ffffff] lg:py-0">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-12">
                {/* Header */}
                <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#000000] text-left mb-8">
                    Reviews About Our Company
                </h2>

                {/* Swiper Section */}
                <Swiper
                    modules={[Autoplay, Pagination]}
                    autoplay={{ delay: 4000, disableOnInteraction: false }}
                    loop={true}
                    pagination={{ clickable: true }}
                    spaceBetween={20}
                    breakpoints={{
                        0: { slidesPerView: 1 },
                        768: { slidesPerView: 2 },
                        1024: { slidesPerView: 3 },
                    }}
                >
                    {reviews.map((r) => (
                        <SwiperSlide key={r.id}>
                            <div className="bg-white border border-gray-200 rounded-2xl shadow hover:shadow-lg transition duration-300 p-6 h-64 flex flex-col justify-between">
                                <div>
                                    {/* Rating + Days */}
                                    <div className="flex justify-between items-center mb-3">
                                        <div className="flex items-center">
                                            <span className="text-xl font-semibold mr-1">{r.rating}</span>
                                            {[...Array(r.rating)].map((_, i) => (
                                                <Star
                                                    key={i}
                                                    className="w-4 h-4 text-yellow-400 fill-yellow-400"
                                                />
                                            ))}
                                        </div>
                                        <span className="text-gray-500 text-sm">{r.daysAgo}</span>
                                    </div>

                                    {/* Review Text */}
                                    <p className="text-gray-700 text-sm leading-relaxed mb-4 line-clamp-4">
                                        {r.review}
                                    </p>
                                </div>

                                {/* Footer */}
                                <div className="flex justify-between items-center border-t pt-3">
                                    <span className="font-medium text-gray-900">{r.name}</span>
                                    <img
                                        src="https://upload.wikimedia.org/wikipedia/commons/2/2f/Google_2015_logo.svg"
                                        alt="Google"
                                        className="w-14"
                                    />
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </section>
    );
}
